module.exports = __webpack_public_path__ + "img/Angiogenesis-BRCA_SpatialResearch.2e373e76.png";